/* Tiny TTS helper using browser SpeechSynthesis */
function pickVoice(lang) {
  const voices = window.speechSynthesis?.getVoices?.() || [];
  // prefer Italian voices when lang starts with "it"
  const langKey = lang.toLowerCase().slice(0, 2);
  return (
    voices.find((v) => v.lang.toLowerCase().startsWith(langKey) && v.localService) ||
    voices.find((v) => v.lang.toLowerCase().startsWith(langKey)) ||
    voices[0]
  );
}

export function speak(text, { lang = "it-IT", rate = 1, pitch = 1, onEnd } = {}) {
  if (!("speechSynthesis" in window) || !text?.trim()) return null;
  window.speechSynthesis.cancel();
  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = lang;
  utter.rate = rate;
  utter.pitch = pitch;
  const voice = pickVoice(lang);
  if (voice) utter.voice = voice;
  if (onEnd) utter.onend = onEnd;
  window.speechSynthesis.speak(utter);
  return utter;
}

export function stop() {
  if ("speechSynthesis" in window) window.speechSynthesis.cancel();
}

export function isSupported() {
  return typeof window !== "undefined" && "speechSynthesis" in window;
}
